










import { Component, Vue } from 'vue-property-decorator';
import InputBox from '@/components/InputBox.vue';
import OutputBox from '@/components/OutputBox.vue';

@Component({
  components: {
    InputBox,
    OutputBox,
  },
})
export default class Home extends Vue {
  public message: string;
  constructor() {
    super();
    this.message = 'Hello world!';
  }
}
